import { REGION } from '@ms/config/app'
import i18n from '@ms/lang/i18n'

const isLocal = process.env.PLATFORM === 'local'

/*
  国家或地区相关配置
  注意：本配置既用于站内分国家打包，也用于游戏本地化不区分国家打包
  例如：mcards 只打包一份提供给 ios app, 支持在 app 内切换国家动态更改配置
 */

// 本地化
if (isLocal) {
  try {
    const envConfig = require('@ms/lang/prod.js').default
    window.REGION_CONFIG = envConfig.get(REGION)
  } catch (error) {
    console.error('LOCAL ERROR:', error)
  }
}

const getCountryValue = (key = '', defaultValue = '') => {
  return window.REGION_CONFIG ? window.REGION_CONFIG[key] : defaultValue
}

// 当前国家
export const getOperId = () => getCountryValue('OPERID', i18n.t('OPERID'))

// api 前缀
const BASE_API_PREFIX = `/api/${REGION}`
export const API_PREFIX = isLocal ? process.env.VUE_APP_ORIGIN.replace(/xx/g, REGION) + BASE_API_PREFIX : BASE_API_PREFIX

// 跳转网页适配器
export function adapterPageUrl(url = '') {
  if (/^http/.test(url)) {
    // 跳转完整路径
    return url
  } else {
    // 跳转站内路径
    const baseUrl = `/${REGION}`
    const reg = new RegExp(`^${baseUrl}`)
    if (reg.test(url)) {
      return url.replace(/^\/[a-z]{2}/i, baseUrl)
    } else {
      return `${baseUrl}${url}`
    }
  }
}

export const getRouterConfig = (pageUrl = '') => {
  if (isLocal) {
    return {
      base: '/',
      mode: 'hash'
    }
  }
  return {
    base: `${adapterPageUrl(pageUrl)}/`,
    mode: ''
  }
}
